module.exports = __webpack_public_path__ + "static/img/ring-logo.1baa7cb.svg";